import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FocusTrapDirective } from './focus-trap.directive';
import { SetInitialFocusDirective } from './set-initial-focus.directive';

@NgModule({
  declarations: [FocusTrapDirective, SetInitialFocusDirective],
  imports: [CommonModule],
  exports: [FocusTrapDirective, SetInitialFocusDirective]
})
export class FocusModule {}

export * from './focus-trap.directive';
export * from './set-initial-focus.directive';
